import * as React from "react"
import * as styles from "./styles.module.scss"
import ScrollCta from "../ScrollCta"

const OurMission: React.FC = () => {
  return (
    <section className={styles.ourMission}>
      <div className={styles.pagePadding}>
        <figure className={styles.figure}>
          <svg
            className={styles.svg}
            width="500"
            height="500"
            viewBox="0 0 500 500"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M337.803069,332.019545 L498.949315,421 L499,199.218064 L337.803069,106.126516 L337.803069,332.019545 Z M165.959624,1 L341.961906,81.922074 L176.414069,199.214068 L176.358049,421 L1,339.02718 L1,119.185594 L165.959624,1 Z"
              fill="#37EBC2"
              fillRule="nonzero"
            />
          </svg>
        </figure>
        <div className={styles.message}>
          <p className={styles.eyebrow}>Our mission</p>
          <h3 className={styles.heading}>
            Improve access to home finance for a new generation of Americans
          </h3>
        </div>
      </div>
      <ScrollCta cta="Learn More" />
    </section>
  )
}

export default OurMission
